import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CalendarClickEvent, CalendarTask } from '@infodata-group/inf-commons';
import { AgendaDetailedOptions } from '../../agenda-detailed-options';
import { ResizingEvent } from '../../resizing-event';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'infl-agenda-detailed-task',
  imports: [NgStyle],
  standalone: true,
  templateUrl: './agenda-detailed-task.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './agenda-detailed-task.scss',
})
export class AgendaDetailedTask {
  public viewTask = input<{ style: any; task: CalendarTask }>();
  public options = input<AgendaDetailedOptions>();

  public taskClick = output<CalendarClickEvent>();
  public taskHover = output<CalendarTask>();
  public startResizing = output<ResizingEvent>();

  protected onTaskClick($event: PointerEvent, task: CalendarTask) {
    this.taskClick.emit(new CalendarClickEvent($event, task));
  }

  protected startResizeTask(
    viewTask: { style: any; task: CalendarTask },
    event: MouseEvent,
    direction: 'top' | 'bottom',
  ) {
    if (this.options().canResize) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const resizingEvent = new ResizingEvent(viewTask, event, direction);
      this.startResizing.emit(resizingEvent);
    }
  }
}
